import type { AppRegion } from '@/entities/region/Region'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { useHead } from '@unhead/react'
import { useEffect } from 'react'
import { useLoginWithUrlCode } from '@/features/auth/oneTimeCode/api'
import { UrlCodeLinking } from '@/features/auth/oneTimeCode/ui'

export const Route = createFileRoute('/_signin/$region/$urlCode')({
  component: UrlCodeLinkingComponent,
})

function UrlCodeLinkingComponent() {
  useHead({
    title: 'Hello Screens - URL Linking',
    meta: [{
      name: 'description',
      content: 'Connecting to Hello Screens',
    }],
  })

  const { region, urlCode } = useParams({ from: '/_signin/$region/$urlCode' })
  const navigate = useNavigate()
  const loginWithUrlCode = useLoginWithUrlCode()

  useEffect(() => {
    async function handleLogin() {
      const success = await loginWithUrlCode({
        urlCode,
        region: region as AppRegion,
      })

      if (success) {
        navigate({
          to: '/dashboard',
          replace: true,
        })
      }
    }

    handleLogin()
  })

  return (
    <UrlCodeLinking />
  )
}
